import type { InventoryLayer } from "@/domain/types";

export const mockInventoryLatest: Omit<InventoryLayer, "id" | "date">[] = [
  {
    sku: "sku001",
    siteId: "site_demo",
    fbaStock: 685,
    fbmStock: 0,
    factoryStock: 240,
    eastTransit: 72,
    westTransit: 88,
    southeast: 40,
    southcentral: 80,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 312, daysOfCover: 31 },
      { warehouse: "美东", qty: 213, daysOfCover: 21 },
      { warehouse: "美中南", qty: 95, daysOfCover: 9 },
      { warehouse: "美东南", qty: 65, daysOfCover: 6 },
    ],
    transitBatches: [
      { warehouse: "物流A-美西", qty: 48, etaDate: "2026-08-02", shipDate: "2026-07-15", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 40, etaDate: "2026-08-10", shipDate: "2026-07-18", statusText: "7/18出港", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美东", qty: 72, etaDate: "2026-08-05", shipDate: "2026-07-20", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 40, etaDate: "2026-08-08", pickupDate: "2026-07-22", statusText: "40-7/22提柜", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 50, etaDate: "2026-08-03", arrivalDate: "2026-07-25", statusText: "50-7/25已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 30, etaDate: "2026-08-12", shipDate: "2026-07-28", status: "in_transit", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 120, totalQty: 600, deliveryDate: "2026-08-25", status: "producing" },
      { factoryName: "演示工厂B", qty: 120, totalQty: 500, deliveryDate: "2026-09-05", status: "ready" },
    ],
  },
  {
    sku: "sku002",
    siteId: "site_demo",
    fbaStock: 520,
    fbmStock: 0,
    factoryStock: 200,
    eastTransit: 56,
    westTransit: 80,
    southeast: 32,
    southcentral: 104,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 245, daysOfCover: 22 },
      { warehouse: "美东", qty: 175, daysOfCover: 16 },
      { warehouse: "美中南", qty: 65, daysOfCover: 6 },
      { warehouse: "美东南", qty: 35, daysOfCover: 3 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 56, etaDate: "2026-08-04", shipDate: "2026-07-16", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 80, etaDate: "2026-08-06", shipDate: "2026-07-18", statusText: "80-7/18出港", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 32, etaDate: "2026-08-09", pickupDate: "2026-07-24", statusText: "32-7/24提柜", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 60, etaDate: "2026-08-01", arrivalDate: "2026-07-26", statusText: "60-7/26已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 44, etaDate: "2026-08-11", shipDate: "2026-07-29", status: "in_transit", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂C", qty: 100, totalQty: 400, deliveryDate: "2026-08-20", status: "producing" },
      { factoryName: "演示工厂A", qty: 100, totalQty: 450, deliveryDate: "2026-09-01", status: "ready" },
    ],
  },
  {
    sku: "sku003",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 502,
    factoryStock: 300,
    eastTransit: 90,
    westTransit: 35,
    southeast: 0,
    southcentral: 120,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 180, daysOfCover: 15 },
      { warehouse: "美东", qty: 140, daysOfCover: 12 },
      { warehouse: "美中南", qty: 112, daysOfCover: 9 },
      { warehouse: "美东南", qty: 70, daysOfCover: 6 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 90, etaDate: "2026-08-03", shipDate: "2026-07-14", statusText: "90-7/14出港", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 35, etaDate: "2026-08-07", shipDate: "2026-07-19", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美中南", qty: 70, etaDate: "2026-08-05", pickupDate: "2026-07-21", statusText: "70-7/21提柜", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 50, etaDate: "2026-08-14", shipDate: "2026-07-30", status: "in_transit", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂D", qty: 150, totalQty: 600, deliveryDate: "2026-08-28", status: "producing" },
      { factoryName: "演示工厂C", qty: 150, totalQty: 500, deliveryDate: "2026-09-10", status: "ready" },
    ],
  },
  {
    sku: "sku004",
    siteId: "site_demo",
    fbaStock: 1620,
    fbmStock: 0,
    factoryStock: 400,
    eastTransit: 0,
    westTransit: 0,
    southeast: 0,
    southcentral: 0,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 680, daysOfCover: 45 },
      { warehouse: "美东", qty: 520, daysOfCover: 34 },
      { warehouse: "美中南", qty: 260, daysOfCover: 17 },
      { warehouse: "美东南", qty: 160, daysOfCover: 11 },
    ],
    transitBatches: [],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 200, totalQty: 800, deliveryDate: "2026-08-30", status: "producing" },
      { factoryName: "演示工厂B", qty: 200, totalQty: 700, deliveryDate: "2026-09-15", status: "ready" },
    ],
  },
  {
    sku: "sku005",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 1242,
    factoryStock: 200,
    eastTransit: 150,
    westTransit: 70,
    southeast: 95,
    southcentral: 70,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 420, daysOfCover: 28 },
      { warehouse: "美东", qty: 380, daysOfCover: 25 },
      { warehouse: "美中南", qty: 270, daysOfCover: 18 },
      { warehouse: "美东南", qty: 172, daysOfCover: 11 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 80, etaDate: "2026-08-02", arrivalDate: "2026-07-24", statusText: "80-7/24已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流A-美东", qty: 70, etaDate: "2026-08-08", shipDate: "2026-07-20", statusText: "70-7/20出港", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美西", qty: 70, etaDate: "2026-08-04", pickupDate: "2026-07-22", statusText: "70-7/22提柜", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 95, etaDate: "2026-08-06", shipDate: "2026-07-17", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 40, etaDate: "2026-08-03", arrivalDate: "2026-07-25", statusText: "40-7/25已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 30, etaDate: "2026-08-10", shipDate: "2026-07-27", status: "in_transit", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂C", qty: 100, totalQty: 400, deliveryDate: "2026-08-22", status: "producing" },
      { factoryName: "演示工厂D", qty: 100, totalQty: 350, deliveryDate: "2026-09-02", status: "ready" },
    ],
  },
  {
    sku: "sku006",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 485,
    factoryStock: 120,
    eastTransit: 20,
    westTransit: 0,
    southeast: 0,
    southcentral: 0,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 180, daysOfCover: 22 },
      { warehouse: "美东", qty: 155, daysOfCover: 19 },
      { warehouse: "美中南", qty: 90, daysOfCover: 11 },
      { warehouse: "美东南", qty: 60, daysOfCover: 7 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 20, etaDate: "2026-08-05", shipDate: "2026-07-25", status: "in_transit", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 60, totalQty: 250, deliveryDate: "2026-08-25", status: "producing" },
      { factoryName: "演示工厂B", qty: 60, totalQty: 200, deliveryDate: "2026-09-05", status: "ready" },
    ],
  },
  {
    sku: "sku007",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 607,
    factoryStock: 180,
    eastTransit: 34,
    westTransit: 25,
    southeast: 0,
    southcentral: 25,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 273, daysOfCover: 27 },
      { warehouse: "美东", qty: 47, daysOfCover: 5 },
      { warehouse: "美中南", qty: 176, daysOfCover: 18 },
      { warehouse: "美东南", qty: 111, daysOfCover: 11 },
    ],
    transitBatches: [
      { warehouse: "物流A-加拿大仓", qty: 10, etaDate: "2026-08-03", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流A-加拿大仓", qty: 7, etaDate: "2026-08-06", shipDate: "2026-07-14", statusText: "7/14出港", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 25, etaDate: "2026-08-02", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 25, etaDate: "2026-08-08", pickupDate: "2026-07-10", statusText: "25-7/10提柜", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 34, etaDate: "2026-08-04", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 34, etaDate: "2026-08-09", arrivalDate: "2026-07-16", statusText: "34-7/16已卸船", status: "receiving", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂E", qty: 180, totalQty: 1200, deliveryDate: "2026-07-31", status: "producing" },
    ],
  },
  {
    sku: "sku008",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 631,
    factoryStock: 180,
    eastTransit: 34,
    westTransit: 25,
    southeast: 0,
    southcentral: 25,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 285, daysOfCover: 26 },
      { warehouse: "美东", qty: 55, daysOfCover: 5 },
      { warehouse: "美中南", qty: 182, daysOfCover: 17 },
      { warehouse: "美东南", qty: 109, daysOfCover: 10 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 34, etaDate: "2026-08-04", shipDate: "2026-07-15", statusText: "34-7/15出港", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 25, etaDate: "2026-08-06", pickupDate: "2026-07-18", statusText: "25-7/18提柜", status: "at_port", shipMethod: "air" },
      { warehouse: "物流B-美中南", qty: 25, etaDate: "2026-08-09", arrivalDate: "2026-07-20", statusText: "25-7/20已卸船", status: "customs", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 90, totalQty: 400, deliveryDate: "2026-08-28", status: "producing" },
      { factoryName: "演示工厂B", qty: 90, totalQty: 350, deliveryDate: "2026-09-08", status: "ready" },
    ],
  },
  {
    sku: "sku010",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 776,
    factoryStock: 220,
    eastTransit: 30,
    westTransit: 0,
    southeast: 0,
    southcentral: 0,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 320, daysOfCover: 32 },
      { warehouse: "美东", qty: 210, daysOfCover: 21 },
      { warehouse: "美中南", qty: 140, daysOfCover: 14 },
      { warehouse: "美东南", qty: 106, daysOfCover: 11 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 30, etaDate: "2026-08-03", shipDate: "2026-07-20", status: "at_port", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂D", qty: 110, totalQty: 450, deliveryDate: "2026-08-20", status: "producing" },
      { factoryName: "演示工厂C", qty: 110, totalQty: 400, deliveryDate: "2026-09-01", status: "ready" },
    ],
  },
  {
    sku: "sku011",
    siteId: "site_demo",
    fbaStock: 112,
    fbmStock: 0,
    factoryStock: 320,
    eastTransit: 20,
    westTransit: 25,
    southeast: 25,
    southcentral: 25,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 48, daysOfCover: 5 },
      { warehouse: "美东", qty: 32, daysOfCover: 3 },
      { warehouse: "美中南", qty: 18, daysOfCover: 2 },
      { warehouse: "美东南", qty: 14, daysOfCover: 1 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 20, etaDate: "2026-08-05", shipDate: "2026-07-22", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流A-美西", qty: 25, etaDate: "2026-08-02", arrivalDate: "2026-07-24", statusText: "25-7/24已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 25, etaDate: "2026-08-07", pickupDate: "2026-07-19", statusText: "25-7/19提柜", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 25, etaDate: "2026-08-04", shipDate: "2026-07-21", statusText: "25-7/21出港", status: "at_port", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂B", qty: 160, totalQty: 600, deliveryDate: "2026-08-25", status: "producing" },
      { factoryName: "演示工厂A", qty: 160, totalQty: 550, deliveryDate: "2026-09-05", status: "ready" },
    ],
  },
  {
    sku: "sku012",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 1,
    factoryStock: 300,
    eastTransit: 25,
    westTransit: 25,
    southeast: 25,
    southcentral: 25,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 0, daysOfCover: 0 },
      { warehouse: "美东", qty: 0, daysOfCover: 0 },
      { warehouse: "美中南", qty: 1, daysOfCover: 0 },
      { warehouse: "美东南", qty: 0, daysOfCover: 0 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 25, etaDate: "2026-08-03", shipDate: "2026-07-15", statusText: "25-7/15出港", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 25, etaDate: "2026-08-06", pickupDate: "2026-07-18", statusText: "25-7/18提柜", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 25, etaDate: "2026-08-08", arrivalDate: "2026-07-20", statusText: "25-7/20已卸船", status: "customs", shipMethod: "air" },
      { warehouse: "物流B-美中南", qty: 25, etaDate: "2026-08-04", shipDate: "2026-07-22", status: "receiving", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂C", qty: 150, totalQty: 500, deliveryDate: "2026-08-22", status: "producing" },
      { factoryName: "演示工厂D", qty: 150, totalQty: 450, deliveryDate: "2026-09-02", status: "ready" },
    ],
  },
  {
    sku: "sku013",
    siteId: "site_demo",
    fbaStock: 186,
    fbmStock: 0,
    factoryStock: 150,
    eastTransit: 20,
    westTransit: 20,
    southeast: 20,
    southcentral: 20,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 55, daysOfCover: 7 },
      { warehouse: "美东", qty: 48, daysOfCover: 6 },
      { warehouse: "美中南", qty: 52, daysOfCover: 6 },
      { warehouse: "美东南", qty: 31, daysOfCover: 4 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 20, etaDate: "2026-08-02", shipDate: "2026-07-20", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流A-美西", qty: 20, etaDate: "2026-08-05", pickupDate: "2026-07-22", statusText: "20-7/22提柜", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流B-美东南", qty: 20, etaDate: "2026-08-07", arrivalDate: "2026-07-24", statusText: "20-7/24已卸船", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 20, etaDate: "2026-08-03", shipDate: "2026-07-18", statusText: "20-7/18出港", status: "receiving", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 75, totalQty: 300, deliveryDate: "2026-08-20", status: "producing" },
      { factoryName: "演示工厂B", qty: 75, totalQty: 250, deliveryDate: "2026-09-01", status: "ready" },
    ],
  },
  {
    sku: "sku014",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 768,
    factoryStock: 260,
    eastTransit: 20,
    westTransit: 0,
    southeast: 0,
    southcentral: 0,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 310, daysOfCover: 31 },
      { warehouse: "美东", qty: 245, daysOfCover: 25 },
      { warehouse: "美中南", qty: 135, daysOfCover: 13 },
      { warehouse: "美东南", qty: 78, daysOfCover: 8 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 20, etaDate: "2026-08-04", shipDate: "2026-07-18", status: "in_transit", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂D", qty: 130, totalQty: 500, deliveryDate: "2026-08-25", status: "producing" },
      { factoryName: "演示工厂C", qty: 130, totalQty: 450, deliveryDate: "2026-09-05", status: "ready" },
    ],
  },
  {
    sku: "sku015",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 620,
    factoryStock: 180,
    eastTransit: 30,
    westTransit: 50,
    southeast: 0,
    southcentral: 30,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 250, daysOfCover: 22 },
      { warehouse: "美东", qty: 195, daysOfCover: 17 },
      { warehouse: "美中南", qty: 120, daysOfCover: 10 },
      { warehouse: "美东南", qty: 55, daysOfCover: 5 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 30, etaDate: "2026-08-03", shipDate: "2026-07-14", statusText: "30-7/14出港", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 50, etaDate: "2026-08-06", pickupDate: "2026-07-18", statusText: "50-7/18提柜", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美中南", qty: 30, etaDate: "2026-08-09", arrivalDate: "2026-07-22", statusText: "30-7/22已卸船", status: "customs", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂B", qty: 90, totalQty: 350, deliveryDate: "2026-08-28", status: "producing" },
      { factoryName: "演示工厂A", qty: 90, totalQty: 300, deliveryDate: "2026-09-08", status: "ready" },
    ],
  },
  {
    sku: "sku016",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 397,
    factoryStock: 240,
    eastTransit: 150,
    westTransit: 95,
    southeast: 40,
    southcentral: 85,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 165, daysOfCover: 11 },
      { warehouse: "美东", qty: 125, daysOfCover: 8 },
      { warehouse: "美中南", qty: 72, daysOfCover: 5 },
      { warehouse: "美东南", qty: 35, daysOfCover: 2 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 80, etaDate: "2026-08-01", arrivalDate: "2026-07-20", statusText: "80-7/20已卸船", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流A-美东", qty: 70, etaDate: "2026-08-08", shipDate: "2026-07-15", statusText: "70-7/15出港", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美西", qty: 60, etaDate: "2026-08-03", pickupDate: "2026-07-18", statusText: "60-7/18提柜", status: "at_port", shipMethod: "sea" },
      { warehouse: "物流B-美西", qty: 35, etaDate: "2026-08-10", shipDate: "2026-07-22", status: "in_transit", shipMethod: "air" },
      { warehouse: "物流B-美东南", qty: 40, etaDate: "2026-08-05", arrivalDate: "2026-07-24", statusText: "40-7/24已卸船", status: "customs", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 50, etaDate: "2026-08-02", shipDate: "2026-07-16", status: "receiving", shipMethod: "sea" },
      { warehouse: "物流B-美中南", qty: 35, etaDate: "2026-08-11", pickupDate: "2026-07-28", statusText: "35-7/28提柜", status: "in_transit", shipMethod: "air" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂C", qty: 120, totalQty: 500, deliveryDate: "2026-08-22", status: "producing" },
      { factoryName: "演示工厂D", qty: 120, totalQty: 450, deliveryDate: "2026-09-02", status: "ready" },
    ],
  },
  {
    sku: "sku017",
    siteId: "site_demo",
    fbaStock: 0,
    fbmStock: 234,
    factoryStock: 140,
    eastTransit: 20,
    westTransit: 10,
    southeast: 0,
    southcentral: 10,
    warehouseBreakdown: [
      { warehouse: "美西", qty: 98, daysOfCover: 14 },
      { warehouse: "美东", qty: 62, daysOfCover: 9 },
      { warehouse: "美中南", qty: 48, daysOfCover: 7 },
      { warehouse: "美东南", qty: 26, daysOfCover: 4 },
    ],
    transitBatches: [
      { warehouse: "物流A-美东", qty: 20, etaDate: "2026-08-04", shipDate: "2026-07-20", status: "in_transit", shipMethod: "sea" },
      { warehouse: "物流A-美西", qty: 10, etaDate: "2026-08-06", pickupDate: "2026-07-22", statusText: "10-7/22提柜", status: "at_port", shipMethod: "air" },
      { warehouse: "物流B-美中南", qty: 10, etaDate: "2026-08-09", arrivalDate: "2026-07-24", statusText: "10-7/24已卸船", status: "customs", shipMethod: "sea" },
    ],
    factoryBatches: [
      { factoryName: "演示工厂A", qty: 70, totalQty: 280, deliveryDate: "2026-08-25", status: "producing" },
      { factoryName: "演示工厂B", qty: 70, totalQty: 250, deliveryDate: "2026-09-05", status: "ready" },
    ],
  },
];